import { createSlice } from "@reduxjs/toolkit";

const resellerCustomerSlice = createSlice({
  name: "resellerCustomer",
  initialState: {
    dueCustomer: [],
    newCustomer: [],
    activeCustomer: [],
    inactiveCustomer: [],
    resellerCustomer: {
      data: [],
    },
    resellerCustomerBillReport: [],
    customers: {
      data: [],
    },
  },
  reducers: {
    getAllResellerCustomerSuccess: (state, actions) => {
      state.customers = actions.payload;
    },
    getResellerCustomerSuccess: (state, actions) => {
      state.resellerCustomer = actions.payload;
    },
    editResellerCustomerSuccess: (state, action) => {
      state.resellerCustomer[
        state.resellerCustomer.findIndex(
          (item) => item.id === action.payload.id,
        )
      ] = action.payload;
    },
    editAllResellerCustomerSuccess: (state, action) => {
      state.customers.data[
        state.customers.data.findIndex((item) => item._id === action.payload.id)
      ] = action.payload;
    },

    bulkUpdate: (state, { payload }) => {
      //get the user type
      const userType = payload[0].userType;
      let customers;
      //get the value from state based on userType
      if (userType === "pppoe") {
        customers = [...state.customers.data];
      } else if (userType === "static") {
        customers = [...state.resellerCustomer.data];
      }
      for (let i = 0; i < customers.length; i++) {
        const element = customers[i];
        for (let j = 0; j < payload.length; j++) {
          if (element?._id === payload[j].id) {
            customers[i] = payload[j];
          }
        }
      }
      //update the state based on userType with modified state
      if (userType === "pppoe") {
        state.customers.data = [...customers];
      } else if (userType === "static") {
        state.resellerCustomer.data = [...customers];
      }
    },

    deleteReCustomer: (state, actions) => {
      state.resellerCustomer.data = state.resellerCustomer.filter(
        (item) => item.id !== actions.payload,
      );
      state.customers.data = state.customers.data?.filter(
        (item) => item.id !== actions.payload,
      );
    },
    bulkCustomerReturn: (state, { payload }) => {
      let customers = [];
      if (payload.isAllCustomer) {
        customers = [...state.customers.data];
      } else {
        customers = [...state.resellerCustomer.data];
      }
      const updatedCustomer = [];
      //loop through existing customer
      for (let i = 0; i < customers.length; i++) {
        const element = customers[i];
        const found = payload.data.find((item) => item.id === element._id);
        if (!found) updatedCustomer.push(element);
      }
      if (payload.isAllCustomer) {
        state.customers.data = updatedCustomer;
      } else {
        state.resellerCustomer = updatedCustomer;
      }
    },

    bulkResellerDelete: (state, { payload }) => {
      //get the user type
      const userType = payload[0].userType;
      let customers;
      //get the value from state based on userType
      if (userType === "pppoe") {
        customers = [...state.resellerCustomer];
      } else if (userType === "simple-queue" || userType === "firewall-queue") {
        customers = [...state.resellerCustomer];
      }
      const updatedCustomer = [];
      //loop through existing customer
      for (let i = 0; i < customers.length; i++) {
        const element = customers[i];
        const found = payload.find((item) => item.id === element.id);
        if (!found) updatedCustomer.push(element);
      }
      //update the state based on userType with modified state
      if (userType === "pppoe") {
        state.resellerCustomer = [...updatedCustomer];
      } else if (userType === "simple-queue" || userType === "firewall-queue") {
        state.resellerCustomer = [...updatedCustomer];
      }
    },

    // reseller single customer bill report action
    getResellerCustomerBillReportSuccess: (state, actions) => {
      state.resellerCustomerBillReport = actions.payload;
    },

    // dashboard click modal action
    getDashboardActiveCustomer: (state, actions) => {
      state.activeCustomer = actions.payload;
    },

    // reseller other customer action
    getNewCustomerSuccess: (state, actions) => {
      state.newCustomer = actions.payload;
    },

    getInactiveCustomerSuccess: (state, actions) => {
      state.inactiveCustomer = actions.payload;
    },

    getDueCustomerSuccess: (state, actions) => {
      state.dueCustomer = actions.payload;
    },
  },
});

export const {
  getDueCustomerSuccess,
  getNewCustomerSuccess,
  getDashboardActiveCustomer,
  getInactiveCustomerSuccess,
  getResellerCustomerSuccess,
  editResellerCustomerSuccess,
  deleteReCustomer,
  getAllResellerCustomerSuccess,
  editAllResellerCustomerSuccess,
  bulkCustomerReturn,
  bulkUpdate,
  bulkResellerDelete,
  getResellerCustomerBillReportSuccess,
} = resellerCustomerSlice.actions;
export default resellerCustomerSlice.reducer;
